import React, { useMemo, useState } from 'react';
import { getActivities } from '../../domain/activities.js';
import { TodayDashboard } from './TodayDashboard.jsx';
import { adaptarAvaliacoes } from './session-adapters.js';
import { gerarPlanosDoDia, loadSessionPlans, upsertSessionPlan } from './session-storage.js';
import { consolidatedAssessment } from '../../lib/assessmentHistory.js';
import { PedagogicalAlertsPanel } from './PedagogicalAlertsPanel.jsx';

export function TeacherCopilotPanel({ data = {}, profissionalId }) {
  const alunos = data.students || data.alunos || [];
  const assessmentHistory = data.assessments || data.avaliacoes || data.diagnoses || [];
  const avaliacoes = adaptarAvaliacoes(alunos.map((aluno) => consolidatedAssessment(assessmentHistory, aluno.id || aluno.alunoId)).filter(Boolean));
  const logs = data.logs || [];
  const peis = data.peis || data.pei || [];
  const caseStudies = data.caseStudies || [];
  const bancoAtividades = useMemo(() => getActivities(data), [data]);
  const [planosSalvos, setPlanosSalvos] = useState(() => loadSessionPlans());

  const alunosVisiveis = useMemo(() => {
    if (!profissionalId) return alunos;
    return alunos.filter((aluno) => {
      const profissionais = aluno.profissionais || aluno.professionalIds || aluno.profissionalIds || [];
      return !profissionais.length || profissionais.includes(profissionalId);
    });
  }, [alunos, profissionalId]);

  const planosDoDia = useMemo(() => gerarPlanosDoDia({
    alunos: alunosVisiveis,
    bancoAtividades,
    avaliacoes,
    logs,
    peis,
    caseStudies,
    profissionalId,
  }), [alunosVisiveis, bancoAtividades, avaliacoes, logs, peis, caseStudies, profissionalId]);

  const persistirPlano = (plano) => {
    const atualizados = upsertSessionPlan(plano);
    setPlanosSalvos(atualizados);
  };

  if (!alunosVisiveis.length) {
    return <section className="teacher-copilot-panel empty"><h2>Assistente pessoal do professor</h2><p>Nenhum aluno visível para o professor atual. Verifique o vínculo em <code>profissionais</code>.</p></section>;
  }

  return (
    <section className="teacher-copilot-panel">
      <PedagogicalAlertsPanel students={alunosVisiveis} assessments={assessmentHistory} logs={logs} peis={peis} professionalId={profissionalId} />
      <TodayDashboard alunos={alunosVisiveis} bancoAtividades={bancoAtividades} avaliacoes={avaliacoes} logs={logs} peis={peis} caseStudies={caseStudies} profissionalId={profissionalId} planosExternos={planosDoDia} onPersistirPlano={persistirPlano} />
      <p className="teacher-copilot-panel__status">{planosSalvos.length || planosDoDia.length} planos disponíveis para revisão humana.</p>
    </section>
  );
}

export default TeacherCopilotPanel;
